import React from 'react';
import WebDevelopmentHero from '../components/WebDevelopmentHero';
import ResponsiveWebsitesSection from '../components/ResponsiveWebsitesSection';
import WebDevelopmentTabs from '../components/WebDevelopmentTabs';
import Counters from '../components/Counters';
import WebDevelopmentPortfolio from '../components/WebDevelopmentPortfolio';
import WebDevWorkflowSection from '../components/WebDevWorkflowSection';
import WhyChooseWebDevelopment from '../components/WhyChooseWebDevelopment';
import WebDevBenefitsSection from '../components/WebDevBenefitsSection';
import IndustryGrid from '../components/IndustryGrid';
import WebDevelopmentTestimonialsSlider from '../components/WebDevelopmentTestimonialsSlider';
import ContactUs from '../components/ContactUs';

const websitesIcon = (
  <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
  </svg>
);

const successfulProjectsIcon = (
  <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z" />
    <polyline points="9.5 11.5 7.5 13 9.5 14.5" />
    <polyline points="14.5 11.5 16.5 13 14.5 14.5" />
    <line x1="13" y1="10.5" x2="11" y2="15.5" />
  </svg>
);

const ratingIcon = (
  <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="6" r="3.5" />
    <path d="M7 16c0-2.5 2.2-4 5-4s5 1.5 5 4" />
    <polygon points="12,14 13,16.5 15.5,16.8 13.5,18.5 14,21 12,19.5 10,21 10.5,18.5 8.5,16.8 11,16.5" />
    <polygon points="6,16 6.8,17.8 8.8,18 7.4,19.4 7.8,21.4 6,20.4 4.2,21.4 4.6,19.4 3.2,18 5.2,17.8" />
    <polygon points="18,16 18.8,17.8 20.8,18 19.4,19.4 19.8,21.4 18,20.4 16.2,21.4 16.6,19.4 15.2,18 17.2,17.8" />
  </svg>
);

const experienceIcon = (
  <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="14" width="3" height="7" rx="0.5" />
    <rect x="8" y="10" width="3" height="11" rx="0.5" />
    <rect x="13" y="6" width="3" height="15" rx="0.5" />
    <rect x="18" y="2" width="3" height="19" rx="0.5" />
    <path d="M3 10c4-4 10-7 18-7m0 0v5m0-5h-5" />
  </svg>
);

const webDevCountersData = [
  { target: 500, suffix: '+', text: 'Websites Developed', icon: websitesIcon },
  { target: 300, suffix: '+', text: 'Successful Projects', icon: successfulProjectsIcon },
  { target: 4.8, decimals: 1, text: 'Client Rating', icon: ratingIcon },
  { target: 10, suffix: '+', text: 'Years of Experience', icon: experienceIcon }
];

function WebDevelopmentPage() {
  return (
    <>
      <WebDevelopmentHero />
      <ResponsiveWebsitesSection />
      <WebDevelopmentTabs />
      <Counters data={webDevCountersData} />
      <WebDevelopmentPortfolio />
      <WebDevWorkflowSection />
      <WhyChooseWebDevelopment />
      <WebDevBenefitsSection />
      <IndustryGrid />
      <WebDevelopmentTestimonialsSlider />
      <ContactUs />
    </>
  );
}

export default WebDevelopmentPage;
